export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5101.6e891539.jpg";